import React from 'react';

const CustomerVin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M0.833984 15.8332V4.1665H2.50065V15.8332H0.833984ZM3.33398 15.8332V4.1665H5.00065V15.8332H3.33398ZM5.83398 15.8332V4.1665H6.66732V15.8332H5.83398ZM8.33399 15.8332V4.1665H10.0007V15.8332H8.33399ZM10.834 15.8332V4.1665H13.334V15.8332H10.834ZM14.1673 15.8332V4.1665H15.0007V15.8332H14.1673ZM16.6673 15.8332V4.1665H19.1673V15.8332H16.6673Z"
                fill="#006CDD"
            />
        </svg>
    );
};

export default CustomerVin;
